export interface AdminStaffCallDailyTotalsDTO {
  contactName: string;
  yesterdayCallCount: number;
  yesterdayCustomerCount: number;
  todayCallCount: number;
  todayCustomerCount: number;
}
